"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Serbian localization
 */
exports.default = {
    /**
     * Welcome page
     */
    skip: 'Preskoči',
    letsStart: 'Krenimo',
    next: 'Dalje',
    registerNow: 'Registruj se sada',
    welcome_title_1: 'Otkrij prvi novčanik zasnovan na NFT-ovima',
    welcome_subtitle_1: 'Kupuj, sakupljaj i trguj predmetima',
    welcome_title_2: 'Kreiraj svoju kolekciju NFT-ova sada',
    welcome_subtitle_2: 'Kupuj, sakupljaj i trguj predmetima',
    welcome_title_3: 'Otkrij uzbudljivi svet kriptovaluta',
    welcome_subtitle_3: 'Kupuj, sakupljaj i trguj predmetima',
    /**
     * Login and registration page
     */
    login: 'Prijavi se',
    welcomeBack: 'Dobrodošli nazad, nedostajali ste nam!',
    noAccount: 'Nemate korisnički račun?',
    register: 'Registracija',
    offline: 'Izgleda da ste offline!',
    checkConnection: 'Proverite vezu i pokušajte ponovo',
    username: 'Korisničko ime',
    usernameOrEmail: 'Korisničko ime ili email',
    usernameRequired: 'Korisničko ime je obavezno *',
    password: 'Lozinka',
    passwordErrorLength: 'Mora imati najmanje 8 karaktera',
    forgotPassword: 'Zaboravili ste lozinku?',
    byClickingRegister: 'Klikom na "Registracija" prihvatate naše',
    privacyNotice: 'Obaveštenje o privatnosti',
    termsAndConditions: 'Uslove korišćenja.',
    and: 'i',
    accountRemoved: 'Korisnički račun obrisan',
    accountRemovedMessage: 'Vaš korisnički račun je uspešno obrisan.',
    /**
     * Reset Password page
     */
    resetPassword: 'Resetuj lozinku',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmNewPassword: 'Potvrdi novu lozinku',
    emailSent: 'Email uspešno poslat!',
    passwordChanged: 'Lozinka promenjena',
    passwordUpdated: 'Vaša lozinka je uspešno ažurirana.',
    incorrectPassword: 'Netačna lozinka',
    passwordDoesNotMatch: 'Lozinke se ne podudaraju. Molimo pokušajte ponovo.',
    close: 'Zatvori',
    emailSentTo: 'Email je poslat na',
    withLinkTo: 'sa linkom za resetovanje lozinke.',
    reset: 'Resetuj',
    passwordResetEmailSent: 'Poslali smo uputstva za resetovanje lozinke na vašu email adresu',
    passwordResetEmailNotSent: 'Nismo mogli poslati uputstva za resetovanje lozinke',
    resetPasswordNote: 'Napomena: Ako pronađemo nalog povezan sa ovom email adresom, dobićete kod za dovršetak resetovanja lozinke.',
    backTo: 'Nazad na',
    resetPasswordRules: 'Vaša lozinka mora sadržati najmanje 8 karaktera i treba da uključuje kombinaciju slova, brojeva i specijalnih karaktera.',
    /**
     * Enrollment page
     */
    wallet: 'Novčanik',
    walletActivationFail: 'Aktivacija novčanika nije uspela.',
    walletActivationFailMessage: 'Došlo je do greške. Molimo pokušajte ponovo kasnije.',
    walletImportSuccess: 'Novčanik uspešno uvezen',
    walletImportSuccessMsg: 'Vaš novčanik je uspešno uvezen.',
    walletNotActivated: 'Novčanik nije aktiviran, pokušajte ponovo',
    important: 'Važno!',
    walletInfo: 'Vaš novčanik je aktiviran. Molimo napravite rezervnu kopiju novčanika i čuvajte je sigurno.',
    ok: 'U redu',
    finish: 'Završi',
    activationSuccessful: 'Aktivacija uspešna',
    importCertificate: 'Uvezi sertifikat',
    activate: 'Aktiviraj',
    reactivate: 'Reaktiviraj',
    activateYourWallet: 'Aktivirajte svoj novčanik',
    reactivateYourWallet: 'Reaktivirajte svoj novčanik',
    import: 'Uvezi',
    walletImportFail: 'Neuspešan uvoz novčanika',
    tryWalletImportAgain: 'Molimo vas da proverite datoteku koju ste odabrali za uvoz i pokušajte ponovo.',
    yourWalletActivated: 'Vaš novčanik je uspešno aktiviran.',
    youWalletActivatedDescription: 'Molimo vas da čuvate svoj novčanik bezbednim. Ne delite ga s drugima jer predstavlja vaš identitet na blockchainu. Savetujemo vam da napravite rezervnu kopiju svog novčanika u slučaju gubitka ili promene uređaja.',
    activateWalletDescription: 'Da biste pristupili svojim kartama, prvo morate aktivirati svoj novčanik. Aktivacija novčanika izdaje sertifikat koji dokazuje vaše vlasništvo nad kartom.',
    reactivateWalletDescription: 'Da biste pristupili svojim kartama, prvo morate ponovo aktivirati svoj novčanik. Ponovna aktivacija novčanika izdaje sertifikat koji dokazuje vaše vlasništvo nad kartom.',
    beSureToBackUp: 'Obavezno napravite rezervnu kopiju svog novčanika nakon aktivacije.',
    beSureToReBackUp: 'Obavezno napravite rezervnu kopiju svog novčanika nakon ponovne aktivacije.',
    youAlreadyActivatedWallet: 'Već ste aktivirali svoj novčanik. Da biste pristupili svojim kartama, moraćete da uvezete svoj sertifikat.',
    importWalletAccessTickets: 'Uvezite svoj novčanik kako biste pristupili svim kupljenim kartama',
    almostDoneImportingWallet: 'Skloro gotovo! Uvoz vašeg novčanika',
    almostDoneActivatingWallet: 'Skloro gotovo! Aktivacija vašeg novčanika',
    almostDoneReactivatingWallet: 'Skloro gotovo! Ponovna aktivacija vašeg novčanika',
    didNotBackUpWallet: 'Ako niste napravili rezervnu kopiju svog sertifikata ili ste izgubili telefon, kontaktirajte podršku @BAMSupport.',
    /**
     * Menu
     */
    myProfile: 'Moj profil',
    save: 'Sačuvaj',
    organizer: 'Organizator',
    signout: 'Odjavi se',
    signoutTitle: 'Da li ste sigurni da želite da se odjavite?',
    signoutMessage: 'Proverite da ste sačuvali sve promene pre nego što se odjavite.',
    applicationSettings: 'Podešavanja aplikacije',
    support: 'Podrška',
    /**
     * Profile page
     */
    account: 'Nalog',
    personalInformation: 'Lični podaci',
    informationUpdated: 'Podaci su uspešno ažurirani!',
    invalidEmail: 'Potreban je validna adresa e-pošte',
    chooseOption: 'Izaberite opciju',
    cancel: 'Otkaži',
    galleryImages: 'Slike iz galerije',
    profilePicture: 'Profilna slika',
    imageNotUploaded: 'Slika nije otpremljena!',
    useCamera: 'Koristi kameru',
    removeAccountError: 'Nalog nije mogao biti uklonjen, pokušajte ponovo.',
    removeAccountSure: 'Da li ste sigurni da želite da uklonite svoj nalog?',
    removeAccountInfo: 'Brisanjem naloga izgubićete sve karte koje trenutno posedujete.',
    removeAccount: 'Ukloni nalog',
    personalData: 'LIČNI PODACI',
    atLeastThreeCharacters: 'Mora imati najmanje 3 karaktera',
    firstname: 'Ime',
    lastname: 'Prezime',
    email: 'E-pošta',
    dateOfBirthday: 'Datum rođenja (opciono)',
    phone: 'Telefon (opciono)',
    address: 'Adresa',
    city: 'Grad',
    state: 'Država',
    country: 'Zemlja',
    location: 'LOKACIJA',
    paypalAccount: 'Paypal Account',
    /**
     * Organizer publish page
     */
    transaction: 'Transakcija',
    transactionPublished: 'Transakcija uspešno objavljena',
    transactionNotPublished: 'Nemogućnost objavljivanja transakcije',
    transactionProcessing: 'Transakcija se trenutno obrađuje, molimo sačekajte!',
    /**
     * Register page
     */
    invalidPassword: 'Lozinka mora imati najmanje 8 karaktera, uključujući bar jedno malo slovo, jedno veliko slovo i jedan broj.',
    invalidUsername: 'Korisničko ime mora biti dugo barem 3 karaktera i može sadržati mala i velika slova latiničnog alfabeta, brojeve, crte i donje crte.',
    letsGetOnBoard: 'Hajde da krenemo!',
    enterValidUsername: 'Unesite validno korisničko ime *',
    enterValidFirstname: 'Unesite validno ime *',
    enterValidLastname: 'Unesite validno prezime *',
    enterValidEmail: 'Unesite validnu email adresu *',
    alreadyHaveAccount: 'Već imate nalog?',
    /**
     * Tickets overview page
     */
    start: 'Početak',
    seating: 'Sjedišta',
    date: 'datum',
    edit: 'Uredi',
    ticketInvalidated: 'Ova ulaznica je već skenirana i iskorištena.',
    dateOfSale: 'Datum prodaje',
    price: 'Cijena',
    expirationDate: 'Datum isteka',
    removeFromMarketPlace: 'Ukloni sa tržišta',
    activateConfirmTitle: 'Da li ste sigurni da želite aktivirati ovu ulaznicu?',
    activateConfirmText: 'Jednom aktivirana, nećete je moći deaktivirati, prenijeti ili prodati.',
    activateTicket: 'Aktiviraj ulaznicu',
    ticketIsProcessed: 'Vaša ulaznica se još uvijek obrađuje - kada bude izdana, moći ćete je prenijeti, prodati i aktivirati.',
    moreInfo: 'Više informacija',
    swipeEventDetails: 'Prevucite za detalje događaja',
    /**
     * Single Ticket screen
     */
    qrCode: 'QR kod',
    ticketCantActivate: 'QR kod ulaznice ostaje zaključan do sedam dana pre događaja.',
    ticketActivateFirst: 'Da biste prikazali QR kod, ulaznica mora prvo biti aktivirana.',
    ticketCantActivateEnded: 'Ne možete aktivirati ulaznicu nakon što je događaj prošao.',
    showQrCodeAtEntrance: 'Prikažite QR kod na ulazu da biste pristupili događaju.',
    options: 'Opcije',
    transferTicketsToFriends: 'Prenesite ulaznice svojim prijateljima besplatno ili ih prodajte na našem sigurnom sekundarnom tržištu.',
    ticket: 'Ulaznica',
    discount: 'Popust',
    dateAndLocation: 'Datum i Lokacija',
    ticketHolder: 'Nosilac ulaznice',
    ticketDetails: 'Detalji ulaznice',
    readMore: 'Pročitaj više',
    eventDetails: 'Detalji događaja',
    buyTickets: 'Kupi ulaznice',
    detailsAboutTicket: 'Detalji o ulaznici',
    detailsAboutEvent: 'Detalji o ovom događaju',
    /**
     * Form input component
     */
    gender: 'Spol (Opcionalno)',
    male: 'Muški',
    female: 'Ženski',
    other: 'Drugo',
    /**
     * Wallet page
     */
    exportShareMessage: 'Sačuvajte svoj novčanik na sigurnom mjestu:',
    backupWallet: 'Backup Novčanika',
    backup: 'Backup',
    backupText: 'Još niste napravili backup svog novčanika, molimo napravite backup kako biste mogli obnoviti svoj novčanik ako zatreba.',
    backupIncomplete: 'Backup nepotpun',
    backupComplete: 'Backup završen',
    backupSuccessTitle: 'Vaš novčanik je uspješno backupiran.',
    backupSuccessInfo: 'Molimo čuvajte svoj novčanik sigurno. Ne dijelite ga s drugima jer predstavlja vašu blockchain identifikaciju.',
    permissionDenied: 'Pristup odbijen, pokušajte ponovno',
    shareMessage: 'Podijelimo neke ulaznice! Evo mog ',
    copied: 'Kopirano',
    add: 'Dodaj',
    connectedWallets: 'Povezani Novčanici',
    connectYourWallet: 'Povežite svoj novčanik',
    connectYourWalletInfo: 'Ako nemate novčanik, možete odabrati pružatelja usluga, preuzeti aplikaciju i sada ga stvoriti.',
    metamask: 'Metamask',
    to: 'na',
    the: 'the',
    downloads: 'downloads',
    folder: 'folder',
    /**
     * Offline page
     */
    offlineHeader: 'Van mreže',
    offlineText: 'Trenutno ste van mreže.',
    offlineSecondText: 'Određene funkcije možda nisu dostupne.',
    /**
     * Home page
     */
    tickets: 'Ulaznice',
    pastExperience: 'Prošla iskustva',
    upcoming: 'Nadolazeće',
    noTickets: 'Još nemate nijednu ulaznicu.',
    checkOutOur: 'Pogledajte naš ',
    ticketMarketplace: 'Marketplace ulaznica',
    toGetThem: ' da biste ih dobili.',
    /**
     * Transfer page
     */
    transferTicket: 'Prenesi ulaznice',
    transferTicketDescription: 'Skenirajte QR kod ili unesite ID novčanika primatelja kako biste odabrali i prenijeli ulaznice.',
    bamWalletShareTitleStart: 'Vaš prijatelj još nema ',
    bamWalletShareTitleEnd: ' aplikaciju? ',
    bamWalletShareSubTitleStart: 'Pozovite svoje prijatelje i podijelite ',
    bamWalletShareSubTitleEnd: ' s njima kako biste omogućili jednostavan prijenos ulaznica.',
    enterWalletId: 'ID novčanika primatelja',
    walletIdError: 'Korisnik nije pronađen / Nepotpun ID',
    share: 'Podijeli',
    transfer: 'Prenesi',
    sell: 'Prodaj',
    sellTicket: 'Prodaj ulaznicu',
    walletId: 'ID novčanika',
    transferModalSbtitle: 'Nakon prijenosa, ulaznice će biti uklonjene iz vašeg novčanika.',
    shareModalTitleStart: 'Podijeli ',
    shareModalTitleEnd: ' s prijateljem',
    succesTransferMessageTile: 'Ulaznice prenesene',
    errorTransferMessageTile: 'Prijenos ulaznica nije uspio',
    succesTransferMessage: 'Vaše ulaznice su uspješno prenesene. Više nisu dostupne u vašem novčaniku.',
    errorTransferMessage: 'Došlo je do pogreške. Pokušajte ponovno kasnije.',
    done: 'Gotovo',
    areYouSureTransfer: 'Jeste li sigurni da želite prenijeti',
    ticketsTo: 'ulaznicu(u) na',
    tryAgain: 'Pokušajte ponovno',
    findUser: 'Pronađi korisnika',
    emailOrWalletId: 'E-pošta ili ID novčanika',
    emailDoesNotExist: 'Ne možemo pronaći korisnika sa ovom e-poštom. Proverite e-poštu ili pritisnite "Pozovi" da pozovete korisnika i prenesete ulaznice.',
    invite: 'Pozovi',
    selectTicketsToTransfer: 'Izaberite ulaznice za prenos: ',
    transferring: 'Prenos ',
    transferringTickets: ' ulaznica.',
    okay: 'U redu',
    sureCancelTransferTo: 'Da li ste sigurni da želite da otkažete prenos korisniku ',
    ifYouCancelNowRepeatLater: 'Ako sada otkažete proces prenosa, možete ga ponoviti kasnije.',
    cancelTransfer: 'Otkaži prenos',
    backToTickets: 'Nazad na ulaznice',
    successSentInvite: 'Uspešno ste poslali pozivnicu korisniku.',
    ableToTransferTicketsNow: 'Moći ćete sada da prenesete ulaznice korisniku.',
    /**
     * Qrcode Scanner
     */
    qrcodeScannerScreenTitle: 'Skeniraj novčanik',
    scanWallet: 'Skeniraj novčanik',
    /**
     * Ticket holder information
     */
    cancelSureTitle: 'Da li ste sigurni da želite odustati?',
    cancelSureText: 'Proverite da li ste sačuvali sve promene pre nego što napustite proces.',
    confirm: 'Potvrdi',
    /**
     * Sell ticket
     */
    sellTickets: 'Prodajte karte',
    setExpiration: 'Postavite datum isteka',
    ticketPrice: 'Cena karte',
    sellTicketConfirmTitle: 'Da li ste sigurni da želite da prodate svoju kartu na sekundarnom tržištu?',
    sellTicketConfirmMessage: 'Imaćete pristup kartama iz svog novčanika i moći ćete da otkažete prodaju.',
    succesSellTile: 'Karte objavljene na tržištu',
    succesSellMessage: 'Vaše karte su uspešno objavljene na sekundarnom tržištu.',
    errorSellTitle: 'Greška prilikom prodaje ulaznice',
    errorSellMessage: 'Došlo je do greške prilikom pokušaja objavljivanja Vaše ulaznice na prodaju. Molimo pokušajte ponovo.',
    sellFeeHintStart: 'Organizator uzima',
    sellFeeHintMiddle: '% proviziju od prodaje za ovaj događaj. Vi ćete dobiti',
    sellNoFeeHint: 'Organizator ne uzima proviziju od prodaje za ovaj događaj. Vi ćete dobiti',
    setExpirationDate: 'Postavi datum isteka',
    payout: 'Isplata',
    payoutHintText1: 'Molimo pružite PayPal nalog ili email adresu koja će se koristiti za isplatu.',
    payoutHintText2: 'Uplate se vrše automatski putem PayPal-a čim se proda Vaša ulaznica. Dobićete obaveštenje putem email-a nakon što se prodaja obradi.',
    payoutHintText3: 'Hvala Vam što koristite našu platformu! Ako imate bilo kakvih pitanja, obratite se našem timu za podršku.',
    publishingTicketToSecondaryMarket: 'Objavljivanje Vaše ulaznice na sekundarnom tržištu.',
    /**
     * Bottom menu
     */
    nft: 'NFT',
    profile: 'Profil',
    /**
     * NFT screen
     */
    myCollection: 'Moja kolekcija',
    noNFTsYet: 'Još nema NFT-ova',
    doNotSeeNFT: 'Ne vidite svoj NFT?',
    importNFTs: 'Uvoz NFT-ova',
    description: 'Opis',
    chain: 'Lanac',
    /**
     * Metamask wallets screen
     */
    selectWallet: 'Odaberi novčanik',
    connectedAddresses: 'Povezane adrese',
    confirmRemoveWalletTitle: 'Jeste li sigurni da želite ukloniti ovu adresu?',
    confirmRemoveWalletText: 'Ako uklonite ovu adresu, sve povezane NFT-ove bit će uklonjene.',
    removeAddress: 'Ukloni adresu',
    /**
     * Metamask add component
     */
    metamaskWalletConnectSuccessTitle: 'Metamask novčanik povezan.',
    metamaskWalletConnectSuccessText: 'Vaš Metamask novčanik je uspješno dodan.',
    metamaskWalletConnectErrorTitle: 'Greška pri povezivanju Metamask novčanika.',
    metamaskWalletConnectErrorText: 'Nije moguće dodati novčanik iz Metamaska.',
    /**
     * App screen
     */
    applicationUpdateTitle: 'Potrebna je ažuriranje aplikacije.',
    applicationUpdateText: 'Dostupna je nova verzija aplikacije koja je potrebna za nastavak. Molimo kliknite ispod kako biste ažurirali na najnoviju verziju.',
    update: 'Ažuriraj',
    understand: 'Razumijem',
    /**
     * Settings
     */
    settings: 'Podešavanja',
    notifications: 'Obaveštenja',
    enableNotifications: 'Omogući obaveštenja',
    eventStart: 'Početak događaja',
    checkIn: 'Prijava',
    none: 'Nijedno',
    minutes: 'minuta',
    hour: 'sat',
    fiveMinutesBefore: '5 minuta pre',
    tenMinutesBefore: '10 minuta pre',
    fifteenMinutesBefore: '15 minuta pre',
    thirtyMinutesBefore: '30 minuta pre',
    fourtyFiveMinutesBefore: '45 minuta pre',
    oneHourBefore: '1 sat pre',
    fiveMinutes: '5 minuta',
    tenMinutes: '10 minuta',
    fifteenMinutes: '15 minuta',
    thirtyMinutes: '30 minuta',
    fourtyFiveMinutes: '45 minuta',
    oneHour: '1 sat',
    language: 'Jezik',
    bs: 'Bosanski',
    de: 'Nemački',
    en: 'Engleski',
    es: 'Španski',
    fr: 'Francuski',
    sr: 'Srpski',
    this: 'Ovo',
    is: 'je',
    near: 'blizu',
    /**
     * Notifications
     */
    today: 'Danas',
    clear: 'Obriši',
    noNewNotifications: 'Nema novih obaveštenja',
    noNewNotificationsHint: 'Sve ste uhvatili! Proverite kasnije za nova obaveštenja.',
    /**
     * Validator App
     */
    /**
     * Login screen
     */
    welcome: 'Welcome',
    scanQrCodeHint: 'Use the QR code shown in your organizer dashboard to login.',
    scanQrCode: 'Scan QR code',
    switchedEnvironment: 'Switched Environment',
    switchedEnvironmentToProd: 'Switched environment to prod',
    switchedEnvironmentToDev: 'Switched environment to dev',
    appVersion: 'App Version',
    /**
     * Login-Scan screen
     */
    qrCodeScannerHint: 'Please scan the organizer QR code to login.',
    loginQrErrorTitle: 'Login failed.',
    loginQrError: 'Please use the correct organiser QR code from the admin dashboard.',
    loginLoading: "Almost done. Please don't exit the application until information is loaded.",
    /**
     * Ticket-Scan screen
     */
    tapToStartScanning: 'Tap to start scanning',
    validTicket: 'Check-In successful!',
    invalidTicket: 'Invalid Ticket!',
    scannedAt: 'Scanned at',
    venueInfoError: 'Unable to fetch venue information',
    signingKeyError: 'Unable to fetch signing key',
    eventInfoError: 'Unable to fetch event information',
    ticketQrError: 'Unable to scan QR-Code',
    scanTickets: 'Scan Tickets',
    ticketCountError: 'Unable to fetch amount of scanned tickets',
    scanAgain: 'Scan again',
    signOutTitle: 'Are you sure you want to Sign Out?',
    signOutText: 'Make sure you saved all the changes you made before signing out.',
    logout: 'Logout',
    checkedIn: 'Checked-in:',
    of: 'of',
    validatingTicket: 'Validating ticket.',
};
//# sourceMappingURL=sr.js.map